import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import TagSearch from "../components/TagSearch";
import * as qs from "query-string";
import StarIcon from "../icons/star_solo.svg";
import BlueStarIcon from "../icons/blue_star.svg";
import GoldStarIcon from "../icons/star_gold.svg";
import { apiUrl } from "../util";
import { pollWithRetryPromise } from "../util/pollingPromiseUtil.js";

class QueueByCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      loading: true,
      tlds: this.getCompanies(),
      today: this.getToday(),
      priorityCompany: false,
      regularPriorityCompany: false,
      competitorAlertPriorityCompany: false,
    };
  }
  cleanupGetDataPolling = null;
  pollingPromise = null;
  componentDidMount() {
    this.getData();
  }
  getCompanies = () => {
    const { companies } = qs.parse(window.location.search);

    if (companies) {
      return companies.split("|");
    }
    return null;
  };
  getToday = () => {
    const { today } = qs.parse(window.location.search);

    return today ? true : false;
  };
  componentWillUnmount() {
    if (this.cleanupGetDataPolling) {
      this.cleanupGetDataPolling();
    }
  }
  getData = () => {
    let url = `${apiUrl}/v1/admin/v2/getQueueItemsByCompany`;

    if (this.state.today) {
      url = `${url}?today=true`;
    }
    const { pollingPromise, cleanup } = pollWithRetryPromise();
    this.pollingPromise = pollingPromise;
    this.cleanupGetDataPolling = cleanup;
    console.log("Fetching data for all company url", {
      url,
      today: this.state.today,
    });
    // request(
    //   {
    //     url,
    //     headers: {
    //       Authorization: this.props.user.token,
    //     },
    //   },
    //   (err, res, data) => {
    //     if (err) {
    //       return;
    //     }
    //     const json = JSON.parse(data);
    //     json.companies.sort((a, b) => {
    //       if (a.name && b.name) {
    //         return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
    //       }
    //     });
    //     let initialCompanies;
    //     const tlds = this.getCompanies();
    //     if (tlds) {
    //       initialCompanies = json.companies
    //         .filter(c => tlds.includes(c.tld))
    //         .map(c => ({ label: `${c.name} (${c.tld})`, value: c.tld }));
    //     }
    //     this.setState({
    //       companies: json.companies.filter(c => c.queue_count > 0),
    //       loading: false,
    //       initialCompanies,
    //     });
    //   }
    // );

    this.pollingPromise({
      url: `${apiUrl}/v1/admin/trigger_polling_data`,
      form: {
        type: "getQueueItemsByCompany",
        clearCache: true,
        data: JSON.stringify({
          today: this.state.today,
        }),
      },
      retryUrl: `${apiUrl}/v1/admin/get_polling_data`,
      retryForm: {
        type: "getQueueItemsByCompany",
        data: JSON.stringify({
          today: this.state.today,
        }),
      },
      token: this.props.user.token,
    })
      .then(json => {
        // const json = data.data;
        console.log("Fetched data:", json);
        json.companies.sort((a, b) => {
          if (a.name && b.name) {
            return a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1;
          } else {
            return 0;
          }
        });
        let initialCompanies;
        const tlds = this.getCompanies();
        if (tlds) {
          initialCompanies = json.companies
            .filter(c => tlds.includes(c.tld))
            .map(c => ({ label: `${c.name} (${c.tld})`, value: c.tld }));
        }
        this.setState({
          companies: json.companies.filter(c => c.queue_count > 0),
          loading: false,
          initialCompanies,
        });

        if (this.cleanupGetDataPolling) {
          this.cleanupGetDataPolling();
          this.cleanupGetDataPolling = null;
        }
      })
      .catch(err => {
        console.error("Error fetching data:", err);
        this.setState({
          loading: false,
        });
      });
  };
  doTldFilter = vals => {
    if (vals && vals.length > 0) {
      this.props.history.push(`/queue/company?companies=${vals.join("|")}`);
    } else {
      this.props.history.push(`/queue/company`);
    }
    this.setState({ tlds: vals });
  };
  doFilter = () => {
    const {
      tlds,
      companies,
      regularPriorityCompany,
      priorityCompany,
      competitorAlertPriorityCompany,
    } = this.state;
    let result = companies;
    if (tlds && tlds.length > 0) {
      result = companies.filter(c => tlds.includes(c.tld));
    }
    if (
      priorityCompany ||
      regularPriorityCompany ||
      competitorAlertPriorityCompany
    ) {
      result = result.filter(c => {
        let found = false;
        if (!found && competitorAlertPriorityCompany && c.competitorPriority) {
          found = true;
        }
        if (priorityCompany && c.priorityCompany) {
          found = true;
        }
        if (!found && regularPriorityCompany && c.regularPriority) {
          found = true;
        }
        return found;
      });
    }
    return result;
  };
  onChangePriorityCompanyFilter = e => {
    const priorityCompany = e.target.checked;
    this.setState({
      priorityCompany: priorityCompany,
    });
  };
  onChangeRegularPriorityCompanyFilter = e => {
    const regularPriorityCompany = e.target.checked;
    this.setState({
      regularPriorityCompany: regularPriorityCompany,
    });
  };
  onChangeCompetitorAlertPriorityCompanyFilter = e => {
    const competitorAlertPriorityCompany = e.target.checked;
    this.setState({
      competitorAlertPriorityCompany: competitorAlertPriorityCompany,
    });
  };
  getCutoffWindowLabel = company => {
    if (company.competitorPriority) {
      return "3-day";
    }
    if (company.highTester) {
      return "7-day";
    }
    return "14-day";
  };

  getCheckinAssignmentMessage = company => {
    const queueClearedOnAll =
      company.queue_cleared_on && typeof company.queue_cleared_on === "object"
        ? company.queue_cleared_on.all
        : null;

    if (!queueClearedOnAll) {
      return null;
    }

    if (!company.cutOffDate) {
      return "Can assign on check-in";
    }

    const cutoff = new Date(company.cutOffDate);
    const clearedOn = new Date(queueClearedOnAll);

    if (Number.isNaN(cutoff.getTime()) || Number.isNaN(clearedOn.getTime())) {
      return null;
    }

    if (clearedOn <= cutoff) {
      return "Can assign on check-in";
    }
    const companyTypes = [];
    if (company.competitorPriority) {
      companyTypes.push("Competitor Alert Priority Company");
    }
    if (company.highTester) {
      companyTypes.push("High Tester Company");
    }
    if (company.priorityCompany) {
      companyTypes.push("Priority Company");
    }
    const companyTypeReason = companyTypes.join(" and ");
    const waitDays = company.competitorPriority
      ? "3"
      : company.highTester || company.priorityCompany
        ? "7"
        : "14";

    return `Cannot assign on check-in: because it is ${companyTypeReason}, it can only be assigned ${waitDays} days after the queue was cleared`;
  };
  render() {
    const { user } = this.props;
    const data = this.doFilter();
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }

    if (this.state.loading) {
      return <h1>Loading&hellip;</h1>;
    }

    return (
      <div>
        <h1>Queues by Company</h1>
        <div className="w-50 flex  items-center">
          <div className="w-50">
            <TagSearch
              options={this.state.companies.map(c => ({
                label: `${c.name} (${c.tld})`,
                value: c.tld,
              }))}
              callback={this.doTldFilter}
              placeholder="Filter by company"
              defaultTags={this.state.initialCompanies}
            />
          </div>
          <div className="ph2 pt1">
            <img
              src={StarIcon}
              alt="show only prioriry company"
              // className="share-icon"
              // style={{ marginTop: "-4px" }}
              className="ph1"
            />
            <span className="ph1">Priority</span>
            <input
              type="checkbox"
              color="primary"
              name="priorityCompany"
              checked={this.state.priorityCompany}
              onChange={this.onChangePriorityCompanyFilter}
            />
          </div>
          <div className="ph2 pt1">
            <img
              src={BlueStarIcon}
              alt="show only regular priority company"
              // className="share-icon"
              // style={{ marginTop: "-4px" }}
              className="ph1"
            />
            <span className="ph1">Regular priority</span>
            <input
              type="checkbox"
              color="primary"
              name="regularPriorityCompany"
              checked={this.state.regularPriorityCompany}
              onChange={this.onChangeRegularPriorityCompanyFilter}
            />
          </div>
          <div className="ph2 pt1">
            <img
              src={GoldStarIcon}
              alt="show only competitor alert priority company"
              // className="share-icon"
              // style={{ marginTop: "-4px" }}
              className="ph1"
            />
            <span className="ph1">Competitor Alert priority</span>
            <input
              type="checkbox"
              color="primary"
              name="competitorAlertPriorityCompany"
              checked={this.state.competitorAlertPriorityCompany}
              onChange={this.onChangeCompetitorAlertPriorityCompanyFilter}
            />
          </div>
        </div>

        {data.map(company => {
          const checkinAssignmentMessage =
            this.getCheckinAssignmentMessage(company);
          const queueClearedOnAll =
            company.queue_cleared_on &&
            typeof company.queue_cleared_on === "object"
              ? company.queue_cleared_on.all
              : null;
          const queueClearedOnDate = queueClearedOnAll
            ? new Date(queueClearedOnAll)
            : null;
          const hasValidQueueClearedOnDate =
            queueClearedOnDate && !Number.isNaN(queueClearedOnDate.getTime());

          return (
            <div className="mt3 f4 flex items-center" key={company.tld}>
              {company.priorityCompany && (
                <img
                  src={StarIcon}
                  // height="20"

                  alt="Priority Company"
                  className="ph1"
                />
              )}
              {company.regularPriority && (
                <img
                  src={BlueStarIcon}
                  // height="20"

                  alt="Regular Priority Company"
                  className="ph1"
                />
              )}
              {company.competitorPriority && (
                <img
                  src={GoldStarIcon}
                  // height="20"

                  alt="Competitor Alert Priority Company"
                  className="ph1"
                />
              )}
              {company.name} ({company.tld}){" "}
              <Link to={`/queue/company/${encodeURIComponent(company.tld)}`}>
                <b>{company.queue_count}</b> items in queue
              </Link>
              {queueClearedOnAll && (
                <span className="ml2 f6 gray">
                  Queue cleared on:{" "}
                  {hasValidQueueClearedOnDate
                    ? queueClearedOnDate.toLocaleDateString()
                    : "N/A"}
                </span>
              )}
              {queueClearedOnAll && checkinAssignmentMessage && (
                <span className="ml2 f6 gray">{checkinAssignmentMessage}</span>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}

export default QueueByCompany;
